import { render, staticRenderFns } from "./AdministracionDePendientes.vue?vue&type=template&id=4b349190&scoped=true&"
import script from "./AdministracionDePendientes.vue?vue&type=script&lang=js&"
export * from "./AdministracionDePendientes.vue?vue&type=script&lang=js&"
import style0 from "./AdministracionDePendientes.vue?vue&type=style&index=0&id=4b349190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b349190",
  null
  
)

export default component.exports